import {
  ORGCHART_FETCHING,
  ORGCHART_FAILED,
  ORGCHART_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ORGCHART_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ORGCHART_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ORGCHART_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
